import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
export default class PrivateComposerPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.configComposer();
  }
  configComposer() {
    if (!app.session.user) {
      setTimeout(() => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal')), 500);
      return m.route.set('/');
    }
    const params = m.route.param();
    const recipients = new ItemList();
    recipients.add("users:".concat(app.session.user.id()), app.session.user);
    const redirect = params.redirect;
    const target = redirect ? redirect.startsWith('/') ? redirect : app.route(redirect) : app.route('byobuPrivate');
    m.route.set(target);
    setTimeout(async () => {
      const composerProps = {
        user: app.session.user,
        recipients: recipients,
        originalContent: null
      };
      if (params.content) {
        composerProps.originalContent = params.content;
      }
      if (params.recipientUsers) {
        params.recipientUsers.split(',').forEach(u => {
          const su = app.store.getById('users', u);
          if (!su) return;
          recipients.add("users:".concat(u), su);
        });
      }
      if (params.recipientGroups) {
        params.recipientGroups.split(',').forEach(g => {
          const sg = app.store.getById('groups', g);
          if (!sg) return;
          recipients.add("groups:".concat(g), sg);
        });
      }
      await app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer').then(() => {
        return import(/* webpackChunkName: 'forum/pages/discussions/PrivateDiscussionComposer', webpackMode: 'lazy-once' */ '../pages/discussions/PrivateDiscussionComposer');
      }), composerProps);
      app.composer.show();
      if (params.title) {
        var _app$composer$fields;
        (_app$composer$fields = app.composer.fields) == null || _app$composer$fields.title(params.title);
      }
    }, 0);
  }
  view() {
    return m("div", null);
  }
}
flarum.reg.add('fof-byobu', 'forum/components/PrivateComposerPage', PrivateComposerPage);